module.exports = __webpack_public_path__ + "components/page-footer/static/mountain-icon-background-1447aeeac97cbb75a4509f0815548943.svg";